module.exports = __webpack_public_path__ + "static/media/navidad16.0b3d62c5.webp";